import { atom } from 'recoil';

export interface LogoVO {
  fileName: string;
  fileType: string;
  base64Data: string;
  size: number;
}

export function createDataUrlFromLogoVO(logoVO: LogoVO): string {
  return `data:${logoVO.fileType};base64,${logoVO.base64Data}`;
}

export const logoState = atom<boolean>({
  default: false,
  key: 'logo'
});
